import React, { Component } from "react";
import Trans from "./../../../../componentsReusable/trans";
import app from "./../../../../common/app";
import config from "./../../../../common/config";
import core from "../../../../common/core";

export default class CreateJoinHeader extends Component {
  componentDidMount() {
    if (this.props.goToTop) {
      this.props.goToTop();
    }
  }
  componentWillUnmount() {
    const { props } = this;
    const { isShowHideMenu } = props;
    isShowHideMenu && isShowHideMenu({ flag: true });
  }

  onClickShareIcon = (e, data) => {
    e.stopPropagation();
    if (this.props.onToggleShareDrawer) {
      this.props.onToggleShareDrawer(data);
    }
  };
  onClickQuestionMark = (event) => {
    event && event.stopPropagation();
    const { props } = this;
    const { isShowQuestionOverlay, compName } = props;
    isShowQuestionOverlay && isShowQuestionOverlay(true, compName);
    //Analytics Event

    if (compName === "contestMyTeam") {
      app.TrackGoogleAnalyticsEventByObj(
        config.enumEventPage.questionMarkButtonMyTeam
      );
    } else if (compName === "contestViewLeaderboard") {
      app.TrackGoogleAnalyticsEventByObj(
        config.enumEventPage.questionMarkButtonLeaderboard
      );
    } else if (compName === "contestLanding") {
      app.TrackGoogleAnalyticsEventByObj(
        config.enumEventPage.questionMarkButtonMyleagues
      );
    }
  };
  onClickPtsSys = (event) => {
    event && event.stopPropagation();
    const { props } = this;
    const { isShowQuestionOverlay } = props;
    isShowQuestionOverlay && isShowQuestionOverlay(true, "helpPtsSys");
    //Analytics Event
    app.TrackGoogleAnalyticsEventByObj(
      config.enumEventPage.pointSystemIconClick
    );
  };

  onClickLeave = () => {
    const { openConfirmLeaveOverlay, leagueObj, leaveLeague, eventBack } =
      this.props;
    if (leaveLeague) {
      openConfirmLeaveOverlay &&
        openConfirmLeaveOverlay({
          isRemove: false,
          leagueName: leagueObj.legname,
          isadmin: leagueObj.isadmin,
          params: {
            clientId: 1,
            leagueCode: leagueObj.legcode,
            leagueId: leagueObj.legid,
            memTeamId: leagueObj.temid,
            isDelete: 1,
          },
          onConfirm: async (params) => {
            //Analytics Event
            let action = config.enumEventPage.leaveLeagueConfirm.action;
            let category = config.enumEventPage.leaveLeagueConfirm.category;
            let opt_label = config.enumEventPage.leaveLeagueConfirm.label;
            const objExtra = {
              isadmin: leagueObj.isadmin ? "Yes" : "No",
              contestCodeId: leagueObj.legcode,
            };
            false &&
              app.googleAnalyticsEventTracking(
                action,
                category,
                opt_label,
                objExtra
              );

            const resp = await leaveLeague(params);
            const retVal =
              resp &&
              resp.action.payload.data &&
              resp.action.payload.data &&
              resp.action.payload.data.Meta &&
              resp.action.payload.data.Meta.RetVal;
            if (retVal === 1) {
              core.CompCacheBusterCookie(config.enumBusters.privateContest);
              eventBack && eventBack();
            }
          },
        });
      //Analytics Event
      let action = config.enumEventPage.leaveLeague.action;
      let category = config.enumEventPage.leaveLeague.category;
      let opt_label = config.enumEventPage.leaveLeague.label;
      const objExtra = {
        isadmin: leagueObj.isadmin ? "Yes" : "No",
        legcode: leagueObj.legcode,
      };
      false &&
        app.googleAnalyticsEventTracking(action, category, opt_label, objExtra);
    }
  };

  render() {
    const {
      eventBack,
      propsHeader,
      enableBack,
      enableHelp,
      enablePtsSys,
      settingIcon,
      showSettingOverlayHandler,
      leagueObj,
      noOfTeams,
      leaveIcon,
      shareIcon,
    } = this.props;
    let backClick = eventBack
      ? {
          onClick: () => {
            eventBack();
            const element = document.querySelector("body");

            // Check if the element exists before adding a class
            if (element) {
              // Add the class to the element
              element.classList.remove("bodyNoScroll");
            }
          },
        }
      : {};
    const propsQuestsionMark = {
      onClick: this.onClickQuestionMark,
    };
    const propsPtsSys = {
      onClick: this.onClickPtsSys,
    };

    const propViewMoreAdmin = {};

    const settingClick = showSettingOverlayHandler
      ? {
          onClick: () => {
            showSettingOverlayHandler(true);
          },
        }
      : null;

    return (
      <div className="m11c-cmo__top">
        {/* {!window.location.href.includes("league") ? ( */}

        {enableBack ? (
          <div className="m11c-cmo__bck">
            <i className="m11ci-back" {...backClick} />
          </div>
        ) : null}

        {/* ) : null} */}
        <div className="m11c-cmo__status">
          <div className="m11c-cmo__mat-num">
            <span>
              {propsHeader.transKey ? (
                <Trans sKey={propsHeader.transKey} />
              ) : null}
            </span>
          </div>
          {noOfTeams && (
            <div className="m11c-cmo__mat-time">
              <span>{`${noOfTeams} ${noOfTeams < 2 ? "Team" : "Teams"}`}</span>
            </div>
          )}
        </div>
        {settingIcon && !leagueObj?.isPublic && (
          <div className="m11c-cmo__bck">
            <i className="m11ci-setting" {...settingClick} />
          </div>
        )}
        {leaveIcon && !leagueObj?.isPublic && (
          <div className="m11c-cmo__bck">
            <i
              className="m11ci-logout"
              onClick={() => {
                this.onClickLeave();
              }}
            />
          </div>
        )}
        {shareIcon && !leagueObj?.isPublic && (
          <div
            className="m11c-cmo__bck"
            onClick={(e) => {
              this.onClickShareIcon(e, leagueObj);
            }}
          >
            <i className="m11ci-share-stroke"></i>
          </div>
        )}
        {/* {enablePtsSys ? (
          <div className="m11c-cmo__pts" {...propsPtsSys}>
            <span>
              <Trans sKey={"pts"} isUpper={true} />
            </span>
          </div>
        ) : null} */}
        {/* {enableHelp ? (
          <div className="m11c-cmo__help" {...propsQuestsionMark}>
            <i className="m11ci-help"></i>
          </div>
        ) : null} */}
      </div>
    );
  }
}
